import { useAuth } from "context/auth-context";
import { removeLoginCookie } from "../../components/LoginForm/LoginFormDao";
import { useNavigate, Link } from "react-router-dom";
import loginImg from "../../assets/img-logout.jpg";
import { useTranslation } from "react-i18next";

export const Logout = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleLogout = () => {
    removeLoginCookie("setLoginCookie");
    localStorage.removeItem("bonusPopup");
    localStorage.removeItem("access_token");
    setAuth(null);
    navigate("/");
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 py-10 bg-canvas">
      <div className="w-full max-w-[420px] zs-card overflow-hidden">
        {/* Illustration is a photo designed for a light plate; keep it on its own inset. */}
        <div className="flex items-center justify-center px-6 pt-6">
          <img
            src={loginImg}
            alt="Logout"
            className="lg:animate-bounce-logout h-[140px] md:h-[180px] w-full rounded-lg object-contain"
          />
        </div>
        <form className="px-6 pt-4 pb-6 sm:px-8 sm:pb-8">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-bold tracking-tight font-display text-ink">{t("logout.ComeBack")}</h1>
            <p className="mt-2 text-sm text-ink-3">{t("logout.para")}</p>
          </div>
          <div className="flex flex-col-reverse gap-3 sm:flex-row">
            <button onClick={() => navigate("/dashboard")} className="flex-1 zs-btn zs-btn-secondary zs-btn-lg">
              {t("logout.btntext1")}
            </button>
            <Link to="/" onClick={handleLogout} className="flex-1 zs-btn zs-btn-primary zs-btn-lg">
              {t("logout.btntext2")}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
